import { api } from '@/api/api';
import { storeOps } from '@/api/store/api_store';
import { pathNotInArrJudge } from '@/api/util';
import { inWindow } from '@/config';
const eventApi = api.getEventApi();
const LOG_PREFIX = '[mail store message]';
const ALLOWED_PATHS = ['/', '/jump', '/index.html', '/readMailComb', '/readMail', '/marketingDataViewer', '/marketingTaskPage', '/strangerMails', '/diagnoseDataViewer'];
export function watchMailMessage() {
    if (!inWindow()) {
        return;
    }
    const notAllowed = pathNotInArrJudge(window.location, ALLOWED_PATHS);
    if (notAllowed) {
        return;
    }
    eventApi.registerSysEventObserver('mailStoreRefresh', {
        name: 'mailStoreRefreshWatcher',
        func(ev) {
            console.log(LOG_PREFIX, ev);
            const refreshType = ev.eventStrData;
            if (refreshType === 'refreshFromDb') {
                if (pathNotInArrJudge(window.location, ['strangerMails', 'readMail', 'writeMail'])) {
                    storeOps.mail.updateMailModelEntriesFromDb(ev);
                }
            }
            else if (refreshType === 'mailOp') {
                storeOps.mail.updateMailEntity(ev);
            }
            else if (refreshType === 'mailTag') {
                storeOps.mail.updateMailTag(Object.assign(Object.assign({}, ev.eventData), { _account: ev === null || ev === void 0 ? void 0 : ev._account }));
            }
            else if (refreshType === 'updateMailEntities') {
                storeOps.mail.updateMailEntities(ev.eventData);
            }
            else if (refreshType === 'resetMailWithDraft') {
                storeOps.mail.resetMailWithDraft(ev.eventData);
            }
        },
    });
}
